export default __webpack_public_path__ + "static/media/url3.a64d17f6.png";